export interface EasternSign {
  key: string;
  title: string;
  symbol: string;
  kanji: string;
  altSymbol?: string;
  svgPath?: string;
  element: 'wood' | 'fire' | 'earth' | 'metal' | 'water';
  elementTitle: string;
  color: string;
  bgGradient: string;
  yearsDescription?: string;
}

export const EASTERN_SIGNS: EasternSign[] = [
  {
    key: 'rat',
    title: 'Крыса',
    symbol: '🐭',
    kanji: '子',
    altSymbol: '🐀',
    svgPath: 'M12 2C8.69 2 6 4.69 6 8c0 2.22 1.21 4.15 3 5.19V15c0 1.66 1.34 3 3 3s3-1.34 3-3v-1.81c1.79-1.04 3-2.97 3-5.19 0-3.31-2.69-6-6-6zm-4 4c.83 0 1.5.67 1.5 1.5S8.83 9 8 9s-1.5-.67-1.5-1.5S7.17 6 8 6zm8 0c.83 0 1.5.67 1.5 1.5S16.83 9 16 9s-1.5-.67-1.5-1.5S15.17 6 16 6zm-4 14c-1.1 0-2 .9-2 2h4c0-1.1-.9-2-2-2z',
    element: 'water',
    elementTitle: 'Вода',
    color: '#1e88e5',
    bgGradient: 'linear-gradient(135deg, #42a5f5 0%, #1565c0 100%)',
    yearsDescription: '1960, 1972, 1984, 1996, 2008, 2020'
  },
  {
    key: 'ox',
    title: 'Бык',
    symbol: '🐮',
    kanji: '丑',
    altSymbol: '🐂',
    svgPath: 'M12 4c-1.1 0-2.07.41-2.83 1.09C7.81 4.29 6.01 4 4 4c0 2.5 1.2 4.7 3.09 6.09C7.03 10.7 7 11.34 7 12c0 2.76 2.24 5 5 5s5-2.24 5-5c0-.66-.03-1.3-.09-1.91C18.8 8.7 20 6.5 20 4c-2.01 0-3.81.29-5.17 1.09C14.07 4.41 13.1 4 12 4zm-3 7c.83 0 1.5.67 1.5 1.5S9.83 14 9 14s-1.5-.67-1.5-1.5S8.17 11 9 11zm6 0c.83 0 1.5.67 1.5 1.5S15.83 14 15 14s-1.5-.67-1.5-1.5S14.17 11 15 11z',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#5d4037',
    bgGradient: 'linear-gradient(135deg, #8d6e63 0%, #4e342e 100%)',
    yearsDescription: '1961, 1973, 1985, 1997, 2009, 2021'
  },
  {
    key: 'tiger',
    title: 'Тигр',
    symbol: '🐯',
    kanji: '寅',
    altSymbol: '🐅',
    svgPath: 'M12 2L9 5H5v4l-3 3 3 3v4h4l3 3 3-3h4v-4l3-3-3-3V5h-4l-3-3zm-3 8c.83 0 1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5S8.17 10 9 10zm6 0c.83 0 1.5.67 1.5 1.5S15.83 13 15 13s-1.5-.67-1.5-1.5S14.17 10 15 10zm-3 4c1.1 0 2 .9 2 2h-4c0-1.1.9-2 2-2z',
    element: 'wood',
    elementTitle: 'Дерево',
    color: '#e65100',
    bgGradient: 'linear-gradient(135deg, #ff9800 0%, #d84315 100%)',
    yearsDescription: '1962, 1974, 1986, 1998, 2010, 2022'
  },
  {
    key: 'rabbit',
    title: 'Кролик',
    symbol: '🐰',
    kanji: '卯',
    altSymbol: '🐇',
    svgPath: 'M9 2c-1.1 0-2 .9-2 2v6.17C5.21 11.21 4 13.45 4 16c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.55-1.21-4.79-3-5.83V4c0-1.1-.9-2-2-2s-2 .9-2 2v5h-2V4c0-1.1-.9-2-2-2zm-1 12c.83 0 1.5.67 1.5 1.5S8.83 17 8 17s-1.5-.67-1.5-1.5S7.17 14 8 14zm8 0c.83 0 1.5.67 1.5 1.5S16.83 17 16 17s-1.5-.67-1.5-1.5S15.17 14 16 14z',
    element: 'wood',
    elementTitle: 'Дерево',
    color: '#43a047',
    bgGradient: 'linear-gradient(135deg, #81c784 0%, #2e7d32 100%)',
    yearsDescription: '1963, 1975, 1987, 1999, 2011, 2023'
  },
  {
    key: 'dragon',
    title: 'Дракон',
    symbol: '🐲',
    kanji: '辰',
    altSymbol: '🐉',
    svgPath: 'M12 2l-2 3H6l1 4-4 2 4 2-1 4h4l2 3 2-3h4l-1-4 4-2-4-2 1-4h-4l-2-3zm-3 8c.83 0 1.5.67 1.5 1.5S9.83 13 9 13s-1.5-.67-1.5-1.5S8.17 10 9 10zm6 0c.83 0 1.5.67 1.5 1.5S15.83 13 15 13s-1.5-.67-1.5-1.5S14.17 10 15 10zm-3 4c1.66 0 3 1.34 3 3h-6c0-1.66 1.34-3 3-3z',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#c2185b',
    bgGradient: 'linear-gradient(135deg, #ec407a 0%, #ad1457 100%)',
    yearsDescription: '1964, 1976, 1988, 2000, 2012, 2024'
  },
  {
    key: 'snake',
    title: 'Змея',
    symbol: '🐍',
    kanji: '巳',
    altSymbol: '🐍',
    svgPath: 'M12 2C9.24 2 7 4.24 7 7c0 2.38 1.66 4.37 3.9 4.88C9.35 12.67 8 14.67 8 17c0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.66-1.34-3-3-3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3h2c0-2.76-2.24-5-5-5s-5 2.24-5 5c0 1.66 1.34 3 3 3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3c0-1.66 1.34-3 3-3s3-1.34 3-3-1.34-3-3-3z',
    element: 'fire',
    elementTitle: 'Огонь',
    color: '#00897b',
    bgGradient: 'linear-gradient(135deg, #26a69a 0%, #00695c 100%)',
    yearsDescription: '1965, 1977, 1989, 2001, 2013, 2025'
  },
  {
    key: 'horse',
    title: 'Лошадь',
    symbol: '🐴',
    kanji: '午',
    altSymbol: '🐎',
    svgPath: 'M18 3l-4 4H9C6.79 7 5 8.79 5 11v8h2v-5h3l3 4h4v-3l-2-3h3V7l-1-4zm-8 7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z',
    element: 'fire',
    elementTitle: 'Огонь',
    color: '#d32f2f',
    bgGradient: 'linear-gradient(135deg, #ef5350 0%, #b71c1c 100%)',
    yearsDescription: '1966, 1978, 1990, 2002, 2014, 2026'
  },
  {
    key: 'sheep',
    title: 'Коза',
    symbol: '🐐',
    kanji: '未',
    altSymbol: '🐏',
    svgPath: 'M6 3c0 2 1 4 3 5v3c0 2.21 1.79 4 4 4s4-1.79 4-4V8c2-1 3-3 3-5-2 0-4 1-5 3-.78-.63-1.81-1-3-1s-2.22.37-3 1C8 4 6 3 6 3zm4 7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4 6c-1.1 0-2 .9-2 2h4c0-1.1-.9-2-2-2z',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#7cb342',
    bgGradient: 'linear-gradient(135deg, #aed581 0%, #558b2f 100%)',
    yearsDescription: '1967, 1979, 1991, 2003, 2015, 2027'
  },
  {
    key: 'monkey',
    title: 'Обезьяна',
    symbol: '🐵',
    kanji: '申',
    altSymbol: '🐒',
    svgPath: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-4 8c.83 0 1.5.67 1.5 1.5S8.83 13 8 13s-1.5-.67-1.5-1.5S7.17 10 8 10zm8 0c.83 0 1.5.67 1.5 1.5S16.83 13 16 13s-1.5-.67-1.5-1.5S15.17 10 16 10zm-4 7c-2.03 0-3.8-1.04-4.81-2.6.24-.13.51-.2.81-.2h7.99c.3 0 .57.07.81.2C15.8 15.96 14.03 17 12 17z',
    element: 'metal',
    elementTitle: 'Металл',
    color: '#fbc02d',
    bgGradient: 'linear-gradient(135deg, #ffd54f 0%, #f57f17 100%)',
    yearsDescription: '1968, 1980, 1992, 2004, 2016, 2028'
  },
  {
    key: 'chicken',
    title: 'Петух',
    symbol: '🐔',
    kanji: '酉',
    altSymbol: '🐓',
    svgPath: 'M12 2c-1.1 0-2 .9-2 2 0 .37.1.71.28 1C9.46 5.37 8 6.99 8 9v3l-3 2 3 1v3h8v-3l3-1-3-2V9c0-3.31-2.69-6-6-6zm-2 7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z',
    element: 'metal',
    elementTitle: 'Металл',
    color: '#fb8c00',
    bgGradient: 'linear-gradient(135deg, #ffa726 0%, #ef6c00 100%)',
    yearsDescription: '1969, 1981, 1993, 2005, 2017, 2029'
  },
  {
    key: 'dog',
    title: 'Собака',
    symbol: '🐶',
    kanji: '戌',
    altSymbol: '🐕',
    svgPath: 'M5 4c0 3 2 5 4 6v2c0 2.21 1.79 4 4 4s4-1.79 4-4v-2c2-1 4-3 4-6-3 0-5 1-6 3-.6-.3-1.3-.5-2-.5s-1.4.2-2 .5C10 5 8 4 5 4zm5 7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm6 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4 4c-1.1 0-2 .9-2 2h4c0-1.1-.9-2-2-2z',
    element: 'earth',
    elementTitle: 'Земля',
    color: '#6d4c41',
    bgGradient: 'linear-gradient(135deg, #8d6e63 0%, #4e342e 100%)',
    yearsDescription: '1970, 1982, 1994, 2006, 2018, 2030'
  },
  {
    key: 'pig',
    title: 'Свинья',
    symbol: '🐗',
    kanji: '亥',
    altSymbol: '🐷',
    svgPath: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-4 7c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm8 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm-1 2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm2 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z',
    element: 'water',
    elementTitle: 'Вода',
    color: '#ab47bc',
    bgGradient: 'linear-gradient(135deg, #ba68c8 0%, #7b1fa2 100%)',
    yearsDescription: '1971, 1983, 1995, 2007, 2019, 2031'
  }
];

export function normalizeEasternKey(val: string | null | undefined): string {
  if (!val) return '';
  const clean = val.trim().toLowerCase();
  const byKey = EASTERN_SIGNS.find(z => z.key.toLowerCase() === clean);
  if (byKey) return byKey.key;
  const byTitle = EASTERN_SIGNS.find(z => z.title.toLowerCase() === clean);
  if (byTitle) return byTitle.key;

  if (clean.startsWith('крыс')) return 'rat';
  if (clean.startsWith('бык') || clean.startsWith('вол')) return 'ox';
  if (clean.startsWith('тигр')) return 'tiger';
  if (clean.startsWith('крол') || clean.startsWith('кот')) return 'rabbit';
  if (clean.startsWith('драк')) return 'dragon';
  if (clean.startsWith('зме')) return 'snake';
  if (clean.startsWith('лошад') || clean.startsWith('конь')) return 'horse';
  if (clean.startsWith('коз') || clean.startsWith('овц')) return 'sheep';
  if (clean.startsWith('обезь')) return 'monkey';
  if (clean.startsWith('петух') || clean.startsWith('кур')) return 'chicken';
  if (clean.startsWith('собак') || clean.startsWith('пес')) return 'dog';
  if (clean.startsWith('свин') || clean.startsWith('кабан') || clean.startsWith('хрю')) return 'pig';
  return '';
}

export function getEasternTitle(keyOrTitle: string | null | undefined): string {
  const key = normalizeEasternKey(keyOrTitle);
  const found = EASTERN_SIGNS.find(z => z.key === key);
  return found ? found.title : (keyOrTitle || '');
}

export function getEasternSign(keyOrTitle: string | null | undefined): EasternSign | undefined {
  const key = normalizeEasternKey(keyOrTitle);
  return EASTERN_SIGNS.find(z => z.key === key);
}

export function getEasternSymbol(keyOrTitle: string | null | undefined): string {
  const sign = getEasternSign(keyOrTitle);
  return sign ? sign.symbol : '🐾';
}

export function getEasternKanji(keyOrTitle: string | null | undefined): string {
  const sign = getEasternSign(keyOrTitle);
  return sign ? sign.kanji : '';
}

export function getEasternSvgPath(keyOrTitle: string | null | undefined): string {
  const sign = getEasternSign(keyOrTitle);
  return sign ? (sign.svgPath || '') : '';
}

/**
 * Расчет животного по году рождения (базовый 12-летний цикл)
 */
export function getEasternSignByYear(year: number): EasternSign {
  // 1900 - Крыса (rat)
  const baseIndex = ((year - 1900) % 12 + 12) % 12;
  return EASTERN_SIGNS[baseIndex];
}
